import React, { FC, useEffect, useState, useMemo } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { observer } from 'mobx-react'
import { IonPage, useIonViewWillEnter } from '@ionic/react'
import './index.scss'

// interface
interface IProps extends IPage, RouteComponentProps {
  mapType?: string;
  locationOBJ: {
    latitude: string;
    longitude: string;
  };
}

/** 选择门店页 */
const StoreDisplayDetail: FC<IProps> = (props) => {
  return (
    <IonPage className='store-detail-page'>
      <div className='bg'>
        店铺详情
      </div>
    </IonPage>
  )
}

export default observer(StoreDisplayDetail)
